// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3WbjP","footer":"ModalCreateQualiphyProcedure_footer__i2MKZ","additionData":"ModalCreateQualiphyProcedure_additionData__2Ksb-"};